import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./shared.css']
})
export class ResetPasswordComponent {
  token = '';
  password = '';
  confirmPassword = '';
  message = '';
  error = '';

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router
  ) {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
  }

  reset(): void {
    this.error = '';
    this.message = '';

    if (this.password !== this.confirmPassword) {
      this.error = 'Passwords do not match';
      return;
    }

    this.auth.resetPassword(this.token, this.password).subscribe({
      next: () => {
        this.message = 'Password reset successfully. Redirecting to login...';
        setTimeout(() => this.router.navigate(['/login']), 1500);
      },
      error: (err) => this.error = err?.error?.error || 'Reset failed'
    });
  }
}